import { render } from "./EmployeeReturns.vue?vue&type=template&id=ca4b7ce4&scoped=true"
import script from "./EmployeeReturns.vue?vue&type=script&lang=js"
export * from "./EmployeeReturns.vue?vue&type=script&lang=js"

import "./EmployeeReturns.vue?vue&type=style&index=0&id=ca4b7ce4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4b7ce4"]])

export default __exports__